import { render, staticRenderFns } from "./positionCoefficientComparison.vue?vue&type=template&id=468f57b5&scoped=true&"
import script from "./positionCoefficientComparison.vue?vue&type=script&lang=js&"
export * from "./positionCoefficientComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468f57b5",
  null
  
)

export default component.exports